// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"251":"checkout","353":"contact","594":"about","854":"menu","884":"admin"}[chunkId] + "." + {"251":"a2bd4e16","353":"f8a66f9d","594":"ec77a408","854":"4d0d94d0","884":"7ce6fabe"}[chunkId] + ".js";
};